import * as PIXI from 'pixi.js'
import { Scene } from './Scene'
import { App } from './App'
import {  SceneType } from '../game/Config'

export class ScenesManager {

    container: PIXI.Container
    scene: Scene | null

    constructor() {
        this.container = new PIXI.Container()
        this.scene = null
    }
//start scenes
    start(scene:SceneType)
{
    // console.log('start new scene')
    if(this.scene)
    {
        this.scene.remove()
    }


    this.scene =new App.config.scenes[scene]()
    this.container.addChild(this.scene.container)
}

}